import { cssProp, view } from '@esui/core';
import '@material/mwc-icon';
import '@material/mwc-icon-button';
import { css, html, nothing } from 'lit';

export class ChipProps {
  text = '';
  leadingIcon = '';
  trailingButtonIcon = 'cancel';
  noTrailingButton = false;
  mini = false;

  onAction?: () => void = undefined;

  @cssProp('--mdc-chip-background-color')
  backgroundColor?: string = undefined;
  @cssProp('--mdc-chip-background-color-hover')
  backgroundColorHover?: string = undefined;
  @cssProp('--mdc-chip-text-color')
  textColor?: string = undefined;
}

function template({
  text,
  leadingIcon,
  noTrailingButton,
  trailingButtonIcon,
  mini,
  onAction,
}: ChipProps) {
  return html`
    <div class="chip" ?mini="${mini}">
      ${leadingIcon
        ? html`<mwc-icon class="chip__icon">${leadingIcon}</mwc-icon>`
        : nothing}
      <span class="chip__text">${text}</span>
      ${!noTrailingButton
        ? html`<mwc-icon-button
            @click="${() => onAction?.()}"
            class="chip__icon"
            icon="${trailingButtonIcon}"
          ></mwc-icon-button>`
        : nothing}
    </div>
  `;
}

export const cssTemplate = css`
  .chip {
    display: inline-grid;
    grid-template-columns: max-content max-content max-content;
    grid-gap: 0.5rem;
    align-items: center;
    justify-items: center;
    height: 2rem;
    padding: 0 0.75rem;
    background-color: var(--mdc-chip-background-color, rgba(0, 0, 0, 0.12));
    color: var(--mdc-chip-text-color, rgba(0, 0, 0, 0.67));
    border-radius: 6.25rem;
    transition: all 0.2s;
    --mdc-icon-size: 1.125rem;
    --mdc-icon-button-size: 1.5rem;
  }

  .chip[mini] {
    font-size: 0.875rem;
    height: 1.2rem;
    padding: 0 0.25rem;
    font-size: 0.875rem;
    --mdc-icon-size: 1.125rem;
    --mdc-icon-button-size: 1.125rem;
  }

  .chip:hover {
    background-color: var(
      --mdc-chip-background-color-hover,
      rgba(0, 0, 0, 0.24)
    );
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.08);
  }

  .chip__text {
    grid-column: 2 / 3;
  }
`;

export const [Chip] = view('esui-mdc-chip', {
  template,
  cssTemplate,
  Props: ChipProps,
  mapBuilder:
    ChipBuilder =>
    (text = '') =>
      ChipBuilder().text(text),
});
